import React from "react";

const Tag = (props) => {

    return (
        <button className={ "flex justify-between w-full py-[10px] px-1 hover:bg-[#F6F6F9]" } key={ props.tag?._id }
                onClick={ () => props.handleChooseList(props.tag) }
        >
            <li
                key={ props.tag?._id }
                className="flex items-center"
            >
                <input
                    type="checkbox"
                    checked={ props.chosenLists?.find((item) => item._id === props.tag?._id) }
                    className={ "CustomCheckbox" }
                />
                <div className={ "flex items-center gap-[6px]" }>
                    <div className={ "NewScheduleListName" } style={{color: props.chosenLists?.find((item) => item._id === props.tag?._id) ? "#7E50EA" : "#15151F"}}>{ props.tag?.name }</div>
                </div>
            </li>
            <img alt={ "Logo" } src={ "/media/icons/tag.svg" }
                 className={ "h-[18px] w-[18px]" }/>
        </button>
    );
};

export default Tag;
